import { BTN_TXT, VALIDATION_MESSAGES } from 'constants/txt'
import { ACTIONS, Can, SUBJECTS } from 'features/Permission'
import { subject } from '@casl/ability'
import { useDispatch, useSelector } from 'react-redux'
import { getUser } from '../../../redux/store/user/getters'
import { setLoading } from '../../../redux/store/common/slice'
import { notification } from '../../../components/Notification'
import { FileUpload } from 'components/FileUpload/FileUpload'
import { PRICE_FILE_TYPES } from '../../../components/FileUpload/constants'
import { validateFileTypes } from '../../../helper/common'
import { uploadInvoices } from '../../../pages/InvoiceData/api'
import { useUpload } from './useUpload'
import { AxiosResponse } from 'axios'

export type TProps = {
  onFinish: () => void
}

export default ({ onFinish }: TProps) => {
  const dispatch = useDispatch()
  const user = useSelector(getUser)

  const { handleUploadFile, disableUploadButton } = useUpload({ onFinish })

  const handleUploadFinanceFiles = async (
    files: File[],
    documentType: string
  ) => {
    try {
      dispatch(setLoading(true))

      const formData = new FormData()
      formData.append(documentType, files[0], files[0].name)

      await uploadInvoices({ file: formData.get(documentType) })
      notification.success({ message: VALIDATION_MESSAGES.SM0044 })
      onFinish()
    } catch (e) {
      const err = e as AxiosResponse
      notification.error({
        message: err?.data.errors ? err?.data.errors : err?.data.file
      })
      console.error(err)
    } finally {
      dispatch(setLoading(false))
    }
  }

  return (
    <Can I={ACTIONS.UPLOAD} a={subject(SUBJECTS.INVOICE_DATA, { ...user })}>
      <FileUpload
        uploadButtonText={BTN_TXT.UPLOAD_INVOICES}
        uploadBtnText={''}
        documentType="price_file"
        uploadFilesProps={{
          multiple: false,
          onDropAccepted: (file) =>
            handleUploadFinanceFiles(file, 'price_file'),
          accept: {
            ...PRICE_FILE_TYPES
          },
          validator: (file) =>
            validateFileTypes(PRICE_FILE_TYPES, file, Infinity)
        }}
        handleUploadFile={handleUploadFile}
        disabled={disableUploadButton}
        tooltipText={''}
      />
    </Can>
  )
}
